import PropTypes from 'prop-types';
import { omitBy, isNil } from 'lodash/fp';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import SidebarContainer from '../SidebarContainer';
import feedsActions from '../../redux/feeds/actions';
import feedMappingsActions from '../../redux/feedMappings/actions';
import ContentPage from '../ContentPage';
import ErrorMessage from '../../components/ErrorMessage';
import './Feed.scss';

import { FeedEditor, NewFeed } from '../../components/FeedEditor';

class Feed extends Component {
  componentDidMount() {
    const { feedId } = this.props.match.params;
    if (feedId) {
      this.props.actions.feedRequest(feedId);
    } else {
      this.props.actions.resetFeed(feedId);
    }
    // Get the feed mappings to display in editing a feed.
    this.props.actions.resetFeedMapping();
    this.props.actions.feedMappingsRequest();
  }

  onCreate = (params) => {
    this.props.actions.createFeedRequest(params);
  };

  onUpdate = (feed) => {
    this.props.actions.updateFeedRequest(feed);
  };

  render() {
    const { feeds, feedMappings } = this.props;
    const { error, fetching } = feeds;
    // nulls are invalid in JSON schema
    const feed = omitBy(isNil)(feeds.feed);
    return (
      <SidebarContainer title={feed.name} logo={feed.logo}>
        <div className="feed-table">
          {error && <ErrorMessage error={error} />}
          {feed.id && (
            <FeedEditor
              feed={feed}
              feedMappings={feedMappings.feedMappings}
              fetching={fetching}
              onUpdate={this.onUpdate}
            />
          )}
          {!feed.id && (
            <NewFeed
              feedMappings={feedMappings.feedMappings}
              fetching={fetching}
              onCreate={this.onCreate}
            />
          )}
        </div>
      </SidebarContainer>
    );
  }
}

Feed.propTypes = {
  match: PropTypes.object,
  actions: PropTypes.object,
  feeds: PropTypes.object,
  feedMappings: PropTypes.object,
};

const mapStateToProps = ({ feeds, feedMappings }) => ({
  feeds,
  feedMappings,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...feedsActions,
      ...feedMappingsActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentPage(Feed));
